import { combineReducers } from 'redux';
import add, { type AddState, initialState as initialAddState } from './add/reducer.tsx';
import deleteReducer, {
	type DeleteState,
	initialState as initialDeleteState,
} from './delete/reducer.tsx';
import edit, { type EditState, initialState as initialEditState } from './edit/reducer.tsx';
import error, { type ErrorState, initialState as initialErrorState } from './error/reducer.tsx';
import page, { initialState as initialPageState } from './page/reducer.tsx';
import type { PageState } from './page/types.tsx';

export type UiState = {
	readonly add: AddState;
	readonly edit: EditState;
	readonly delete: DeleteState;
	readonly error: ErrorState;
	readonly page: PageState;
};

export const initialState: UiState = {
	add: initialAddState,
	edit: initialEditState,
	delete: initialDeleteState,
	error: initialErrorState,
	page: initialPageState,
};

const combinedReducer = combineReducers({
	add,
	edit,
	delete: deleteReducer,
	error,
	page,
});
export default combinedReducer;
